.bk-root {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background:
    repeating-conic-gradient(rgba(255,223,158,.025) 0 25%, transparent 0 50%) 0 0 / 24px 24px,
    radial-gradient(900px 320px at 50% -80px, #6b4426 0, transparent 65%),
    linear-gradient(180deg, var(--cocoa) 0, var(--cocoa-deep) 100%);
  color: var(--paper);
  overflow-x: clip;
  max-width: 100%;
}
.bk-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: calc(10px + var(--sait)) 14px 10px;
  padding-left: calc(14px + var(--sail));
  padding-right: calc(14px + var(--sair));
  background: linear-gradient(180deg, #7a4a2b 0, var(--wood) 70%, #4a2a18 100%);
  border-bottom: var(--outline);
  box-shadow: 0 4px 0 rgba(0,0,0,.35);
  flex-wrap: wrap;
  position: sticky;
  top: 0;
  z-index: 30;
}
.bk-header::after {
  content: "";
  position: absolute;
  left: 0; right: 0; bottom: -8px;
  height: 4px;
  background: repeating-linear-gradient(90deg, var(--ink) 0 12px, transparent 12px 20px);
  opacity: .35;
  pointer-events: none;
}
.bk-brand { display: flex; align-items: center; gap: 10px; min-width: 0; }
button.bk-brand { background: transparent; border: 0; padding: 0; margin: 0; font: inherit; color: inherit; cursor: pointer; text-align: left; box-shadow: none; appearance: none; }
button.bk-brand:focus-visible { outline: 3px solid var(--chip); outline-offset: 4px; border-radius: 12px; }
.bk-brand-ico {
  width: 44px; height: 44px;
  border-radius: 14px;
  display: grid; place-items: center;
  font-size: 26px;
  background: var(--cream);
  border: var(--outline);
  box-shadow: var(--shadow-hard);
  flex: none;
}
.bk-brand-text { display: flex; flex-direction: column; line-height: 1.05; }
.bk-brand-name {
  font-family: var(--font-pixel);
  font-size: 12px;
  color: #fff;
  text-shadow: 2px 2px 0 var(--ink);
  white-space: nowrap;
}
.bk-brand-lv {
  font-size: 11px; font-weight: 900;
  color: var(--ink);
  background: var(--chip);
  border: 3px solid var(--ink);
  border-radius: var(--r-pill);
  padding: 1px 9px;
  width: fit-content;
  margin-top: 5px;
  box-shadow: 0 2px 0 var(--ink);
}
.bk-cookie-pill {
  display: flex; align-items: center; gap: 10px;
  margin: 0 auto;
  background: var(--paper);
  border: var(--outline);
  border-radius: var(--r-pill);
  padding: 6px 8px 6px 16px;
  box-shadow: var(--shadow-hard);
  color: var(--ink);
}
.bk-cookie-pill .num {
  font-size: 17px;
  color: var(--ink);
  white-space: nowrap;
}
.bk-cookie-pill .cps {
  font-size: 12px; font-weight: 900;
  color: var(--mint-deep);
  background: #d8f5df;
  border: 3px solid var(--ink);
  border-radius: var(--r-pill);
  padding: 3px 10px;
  white-space: nowrap;
}
.bk-head-right { display: flex; align-items: center; gap: 10px; margin-left: auto; }
.bk-avatars { display: flex; align-items: center; }
.bk-ava {
  width: 30px; height: 30px;
  border-radius: 50%;
  display: grid; place-items: center;
  font-size: 13px; font-weight: 900;
  color: #fff;
  border: 3px solid var(--paper);
  margin-left: -9px;
  box-shadow: 0 2px 0 var(--ink);
  text-shadow: 1px 1px 0 #000;
}
.bk-ava:first-child { margin-left: 0; }
.bk-ava.more { background: var(--wood); font-size: 11px; font-family: var(--font-pixel); }
.bk-event-chip {
  font-size: 12px; font-weight: 900;
  color: #fff;
  background: var(--wood-dark);
  border: 3px solid var(--ink);
  border-radius: var(--r-pill);
  padding: 5px 12px;
  white-space: nowrap;
  box-shadow: 0 3px 0 var(--ink);
}
.bk-event-chip.live { background: var(--mint-deep); }
.bk-event-chip.rush {
  background: var(--cherry);
  border-color: var(--ink);
  outline: 3px solid var(--chip);
  outline-offset: 1px;
  animation: bk-pulse 1s infinite alternate;
}
.bk-self { display: flex; align-items: center; gap: 8px; }
.bk-mute {
  background: var(--paper);
  color: var(--ink);
  border: 3px solid var(--ink);
  border-radius: 12px;
  font-size: 16px;
  width: 44px; height: 44px;
  display: grid; place-items: center;
  cursor: pointer;
  box-shadow: var(--shadow-hard);
  flex: none;
  touch-action: manipulation;
}
.bk-mute:active { transform: translateY(2px); box-shadow: 0 1px 0 var(--ink); }
.bk-xp-wrap { position: relative; display: inline-flex; }
.bk-xp-tip {
  position: absolute; top: calc(100% + 8px); right: 0;
  min-width: 210px; max-width: min(280px, 80vw);
  background: var(--paper); color: var(--ink);
  border: var(--outline); border-radius: 12px; box-shadow: var(--shadow-pop);
  padding: 8px; display: flex; flex-direction: column; gap: 6px;
  opacity: 0; visibility: hidden; pointer-events: none;
  transition: opacity .15s, transform .15s, visibility .15s;
  transform: translateY(4px);
  z-index: 40;
}
.bk-xp-wrap:hover .bk-xp-tip, .bk-xp-wrap:focus-visible .bk-xp-tip, .bk-xp-wrap:focus-within .bk-xp-tip {
  opacity: 1; visibility: visible; pointer-events: auto; transform: translateY(0);
}
.bk-xp-track { height: 12px; background: var(--ink); border-radius: var(--r-pill); overflow: hidden; border: 2px solid var(--ink); position: relative; box-shadow: none; }
.bk-xp-fill { display: block; height: 100%; background: repeating-linear-gradient(-45deg, var(--chip) 0 10px, #ffe08a 10px 20px); box-shadow: none; }
.bk-brand-xp { display: flex; margin-top: 5px; }
.bk-brand-xp .bk-xp-track { width: 172px; max-width: 44vw; height: 18px; display: flex; align-items: center; justify-content: center; }
.bk-brand-xp-row { display: flex; align-items: center; gap: 6px; margin-top: 4px; }
.bk-brand-xp-row .bk-brand-xp { margin-top: 0; }
.bk-brand-xp-row .bk-xp-track { width: 132px; max-width: 32vw; height: 16px; }
.bk-xp-div { width: 2px; align-self: stretch; min-height: 16px; background: rgba(255,243,208,.45); border-radius: 1px; flex: none; }
.bk-brand-xp .bk-xp-fill { position: absolute; left: 0; top: 0; bottom: 0; height: auto; }
.bk-xp-text { position: relative; z-index: 1; font-size: 10px; font-weight: 900; color: #fff; background: rgba(20,12,6,.72); padding: 2px 8px; border-radius: 999px; border: 1px solid rgba(255,243,208,.45); text-shadow: 0 1px 2px rgba(0,0,0,.9); white-space: nowrap; line-height: 1; }
.bk-self-ava {
  position: relative;
  width: 36px; height: 36px;
  border-radius: 50%;
  background: var(--cream);
  display: grid; place-items: center;
  font-weight: 900;
  color: var(--ink);
  border: 3px solid var(--paper);
  outline: 3px solid var(--ink);
  flex: none;
}
.bk-self-ava i {
  position: absolute; right: -2px; bottom: -2px;
  width: 11px; height: 11px; border-radius: 50%;
  background: var(--mint);
  border: 2px solid var(--ink);
}
.bk-credits {
  font-family: var(--font-pixel);
  font-size: 12px;
  color: var(--chip);
  text-shadow: 2px 2px 0 var(--ink);
  white-space: nowrap;
}
.bk-authbtn {
  background: var(--chip);
  color: var(--ink);
  border: 3px solid var(--ink);
  border-radius: 12px;
  font-weight: 900; font-size: 12px;
  padding: 7px 13px;
  cursor: pointer;
  box-shadow: var(--shadow-hard);
  text-decoration: none;
  white-space: nowrap;
  min-height: 44px;
  min-width: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  touch-action: manipulation;
  max-width: 100%;
}
.bk-authbtn:active { transform: translateY(3px); box-shadow: 0 1px 0 var(--ink); }
.bk-reconnect {
  background: var(--cherry);
  border-bottom: var(--outline);
  color: #fff;
  text-align: center;
  font-size: 13px; font-weight: 900;
  padding: 7px 10px;
  text-shadow: 1px 1px 0 var(--ink);
}
.bk-reconnect.warn {
  background: #b45309;
  border-bottom: 4px solid var(--ink);
  color: #fff7ed;
}
.bk-reconnect.info {
  background: #57534e;
  border-bottom: 4px solid var(--ink);
  color: #fff7ed;
  text-shadow: 1px 1px 0 var(--ink);
}
.bk-toast-err {
  background: #fef2f2;
  border: 3px solid #991b1b;
  color: #7f1d1d;
}
.bk-main {
  flex: 1 1 auto;
  min-width: 0;
  display: grid;
  grid-template-columns: 240px minmax(0,1fr) 258px;
  gap: 14px;
  padding: 14px;
  padding-left: calc(14px + var(--sail));
  padding-right: calc(14px + var(--sair));
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  align-items: start;
  overflow-x: clip;
}
.bk-main.bk-single {
  grid-template-columns: minmax(0,1fr);
}
.bk-main > .bk-stage:only-child {
  grid-column: 1 / -1;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
.bk-side {
  position: relative;
  background: var(--paper);
  border: var(--outline);
  border-radius: var(--r-card);
  box-shadow: var(--shadow-pop);
  padding: 14px 12px 12px;
  color: var(--ink);
  min-width: 0;
  flex: none;
}
.bk-side::before, .bk-side::after {
  content: "";
  position: absolute;
  top: -10px;
  width: 56px; height: 18px;
  background: rgba(255,223,158,.85);
  border: 2px solid rgba(58,33,21,.35);
  transform: rotate(-6deg);
  border-radius: 2px;
}
.bk-side::before { left: 14px; }
.bk-side::after { right: 14px; transform: rotate(6deg); }
.bk-side-title {
  font-family: var(--font-pixel);
  font-size: 11px;
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 10px;
  color: var(--ink);
}
.bk-side-count {
  font-family: var(--font-pixel);
  font-size: 9px;
  background: var(--berry);
  border: 2px solid var(--ink);
  color: #fff;
  padding: 3px 8px;
  border-radius: var(--r-pill);
}
.bk-roster { list-style: none; margin: 0; padding: 4px 4px 4px 2px; display: flex; flex-direction: column; gap: 7px; max-height: min(52vh, 420px); overflow-y: auto; overflow-x: visible; overscroll-behavior: contain; scrollbar-width: thin; scrollbar-color: var(--wood) var(--cream); }
.bk-roster li { overflow: visible; }
.bk-ava-wrap { position: relative; display: inline-flex; flex: none; overflow: visible; }
.bk-lvlbadge { position: absolute; right: -6px; bottom: -4px; font-family: var(--font-pixel); font-size: 7px; line-height: 1; background: var(--chip); color: var(--ink); border: 2px solid var(--ink); border-radius: 999px; padding: 1px 4px; box-shadow: 0 1px 0 var(--ink); white-space: nowrap; pointer-events: none; z-index: 1; }
.bk-roster li {
  display: flex; align-items: center; gap: 8px;
  background: #fff9e6;
  border: 3px solid var(--ink);
  border-radius: 12px;
  padding: 5px 8px;
  font-size: 13px; font-weight: 800;
  box-shadow: 0 2px 0 var(--ink);
}
.bk-roster li.me { background: #fff0b8; }
.bk-roster li.me.rushing { background: #fff0b8; outline: 3px solid var(--chip); outline-offset: 1px; }
.bk-roster li.hoverable { cursor: pointer; }
.bk-roster li.hoverable:hover, .bk-roster li.hoverable:focus-visible, .bk-roster li.hovered { background: #fff0b8; outline: 3px solid var(--berry); outline-offset: 1px; }
.bk-username { font-size: 12px; font-weight: 900; color: var(--paper); text-shadow: 1px 1px 0 var(--ink); white-space: nowrap; max-width: 120px; overflow: hidden; text-overflow: ellipsis; }
.bk-ring {
  width: 28px; height: 28px;
  border-radius: 50%;
  display: grid; place-items: center;
  color: #fff; font-size: 13px; font-weight: 900;
  border: 3px solid var(--ink);
  flex: none;
  text-shadow: 1px 1px 0 #000;
}
.bk-rname { flex: 1; color: var(--ink); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bk-rspec { font-size: 10px; color: var(--ink-soft); font-weight: 900; background: var(--cream); border: 2px solid var(--ink); padding: 1px 7px; border-radius: var(--r-pill); }
.bk-more { margin-top: 8px; font-family: var(--font-pixel); font-size: 10px; color: var(--ink-soft); }
.bk-quiet {
  margin-top: 10px; font-size: 13px; font-weight: 700;
  background: #fff9e6;
  border: 3px dashed var(--ink);
  border-radius: 12px;
  padding: 10px;
  color: var(--ink-soft);
  line-height: 1.45;
  opacity: 1;
  transform: translateY(0);
  max-height: 100px;
  overflow: hidden;
  transition: opacity 0.55s ease, transform 0.55s ease, max-height 0.55s ease, margin 0.55s ease, padding 0.55s ease, border-width 0.2s ease;
}
.bk-quiet:not(.visible) {
  opacity: 0;
  transform: translateY(-6px);
  max-height: 0;
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0;
  border-width: 0;
  pointer-events: none;
}
.bk-stage {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  flex: 1 1 auto;
  width: 100%;
}
.bk-status {
  align-self: center;
  display: flex; gap: 8px; align-items: baseline;
  font-family: var(--font-pixel);
  font-size: 11px;
  background: var(--paper);
  border: var(--outline);
  border-radius: var(--r-pill);
  padding: 8px 18px;
  box-shadow: var(--shadow-hard);
  color: var(--ink);
}
.bk-status span { font-family: var(--font-round); font-size: 12px; font-weight: 800; color: var(--ink-soft); }
.bk-status.quiet { background: #e8f0ff; }
.bk-status.baking { background: #dcf5d4; }
.bk-status.busy { background: var(--cream); }
.bk-status.rush { background: var(--chip); animation: bk-pulse 1.1s infinite alternate; }
.bk-status.chaos { background: #ffd9e2; border-color: var(--ink); outline: 3px solid var(--cherry); outline-offset: 2px; animation: bk-pulse .6s infinite alternate; }
@keyframes bk-pulse { from { transform: scale(1); } to { transform: scale(1.05); } }
.bk-scene {
  position: relative;
  border: var(--outline);
  border-radius: 20px;
  overflow: hidden;
  min-height: 580px;
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
  box-sizing: border-box;
  box-shadow: var(--shadow-pop), inset 0 0 90px rgba(0,0,0,.45);
  background: #3d2414;
  touch-action: manipulation;
  user-select: none;
}
.bk-scene.chaos { animation: bk-shake .45s infinite; }
@keyframes bk-shake { 0%,100% { transform: translate(0,0); } 25% { transform: translate(-3px,1px); } 50% { transform: translate(3px,-1px); } 75% { transform: translate(-2px,-1px); } }
.bk-wall {
  position: absolute; inset: 0 0 48% 0;
  background:
    linear-gradient(rgba(0,0,0,.28), transparent 60%),
    repeating-conic-gradient(rgba(0,0,0,.14) 0 25%, transparent 0 50%) 0 0 / 12px 12px,
    repeating-linear-gradient(0deg, rgba(42,20,8,.55) 0 4px, transparent 4px 30px),
    repeating-linear-gradient(90deg, rgba(42,20,8,.55) 0 4px, transparent 4px 62px),
    linear-gradient(180deg, #a05a2e 0, #7c421f 55%, #5a2e14 100%);
}
.bk-beams {
  position: absolute; top: 0; left: 0; right: 0; height: 30px;
  background:
    linear-gradient(180deg, #2c1a0e 0 8px, #5a3421 8px 22px, #2c1a0e 22px 30px);
  border-bottom: 4px solid var(--ink);
  z-index: 2;
}
.bk-beams::after {
  content: "";
  position: absolute; inset: 8px 0 8px 0;
  background: repeating-linear-gradient(90deg, transparent 0 90px, #2c1a0e 90px 104px);
}
.bk-oven {
  position: absolute;
  left: 50%; top: 7%;
  width: min(440px, 76%);
  height: 238px;
  transform: translateX(-50%);
  background: linear-gradient(180deg, #8d8578 0, #6b6257 18%, #4a3421 18.5%, #2c1a0c 100%);
  border: 4px solid var(--ink);
  border-radius: 130px 130px 18px 18px;
  box-shadow: inset 0 6px 0 rgba(255,255,255,.25), inset 0 -18px 30px rgba(0,0,0,.5), 0 0 54px rgba(255,150,40,.35);
  z-index: 1;
  overflow: hidden;
}
.bk-oven-mouth {
  position: absolute; left: 12%; right: 12%; bottom: 14px; height: 92px;
  border-radius: 70px;
  background: radial-gradient(130px 60px at 50% 65%, #ffe9a8 0, var(--crust) 42%, #a83208 76%, #2c1204 100%);
  border: 4px solid var(--ink);
  box-shadow: 0 0 34px rgba(255,180,60,.9), inset 0 0 24px rgba(120,30,0,.7);
  overflow: hidden;
}
.bk-fire {
  position: absolute; inset: 8px;
  display: flex; align-items: flex-end; justify-content: center; gap: 4px;
}
.bk-fire i {
  width: 18px; border-radius: 50% 50% 6px 6px;
  background: linear-gradient(180deg, #fff6c8 0, var(--chip) 35%, var(--crust) 70%, var(--cherry) 100%);
  border: 2px solid rgba(58,33,21,.6);
  transform-origin: bottom center;
  animation: bk-fire .55s infinite alternate ease-in-out;
}
.bk-fire i:nth-child(1) { height: 44px; animation-delay: 0s; }
.bk-fire i:nth-child(2) { height: 62px; animation-delay: -.15s; width: 22px; }
.bk-fire i:nth-child(3) { height: 50px; animation-delay: -.3s; }
.bk-fire i:nth-child(4) { height: 66px; animation-delay: -.1s; width: 24px; }
.bk-fire i:nth-child(5) { height: 46px; animation-delay: -.25s; }
.bk-fire i:nth-child(6) { height: 58px; animation-delay: -.4s; }
.bk-fire i:nth-child(7) { height: 42px; animation-delay: -.2s; }
@keyframes bk-fire { from { transform: scaleY(1) skewX(-3deg); filter: brightness(1); } to { transform: scaleY(1.18) skewX(3deg); filter: brightness(1.2); } }
.bk-scene.rush .bk-fire i { animation-duration: .28s; }
.bk-scene.rush .bk-oven { box-shadow: inset 0 6px 0 rgba(255,255,255,.3), 0 0 80px rgba(255,210,63,.8); }
.bk-shelf {
  position: absolute; top: 12%;
  display: flex; gap: 8px; align-items: flex-end;
  background: linear-gradient(180deg, #7a4a2b, #4a2a18);
  border: 3px solid var(--ink);
  border-radius: 8px;
  padding: 8px 10px 10px;
  box-shadow: 0 4px 0 var(--ink);
  z-index: 2;
}
.bk-shelf.left { left: 3%; }
.bk-shelf.right { right: 3%; }
.bk-shelf i { font-style: normal; font-size: 26px; filter: drop-shadow(2px 2px 0 var(--ink)); animation: bk-bob 2.6s ease-in-out infinite alternate; }
.bk-shelf i:nth-child(2) { animation-delay: -.8s; }
.bk-shelf i:nth-child(3) { animation-delay: -1.6s; }
@keyframes bk-bob { from { transform: translateY(0); } to { transform: translateY(-3px); } }
.bk-lamps { position: absolute; top: 30px; left: 0; right: 0; display: flex; justify-content: space-around; pointer-events: none; z-index: 3; }
.bk-lamp { display: flex; flex-direction: column; align-items: center; position: relative; }
.bk-lamp::before { content: ""; width: 4px; height: 40px; background: var(--ink); }
.bk-lamp-bulb {
  width: 30px; height: 30px; border-radius: 8px;
  background: radial-gradient(circle at 50% 40%, #fff6c8 0, var(--chip) 45%, var(--crust) 100%);
  border: 3px solid var(--ink);
  box-shadow: 0 0 28px 8px rgba(255,210,90,.75);
  animation: bk-sway 3.4s ease-in-out infinite alternate;
}
.bk-lamp-glow {
  position: absolute; top: 52px;
  width: 170px; height: 170px;
  background: radial-gradient(circle, rgba(255,220,130,.38) 0, transparent 68%);
  pointer-events: none;
}
@keyframes bk-sway { from { transform: rotate(-7deg); } to { transform: rotate(7deg); } }
.bk-floor {
  position: absolute; inset: 50% 0 0 0;
  background:
    radial-gradient(480px 240px at 50% 38%, rgba(255,205,120,.42), transparent 70%),
    repeating-conic-gradient(rgba(58,33,21,.22) 0 25%, rgba(255,180,110,.14) 0 50%) 0 0 / 72px 72px,
    linear-gradient(180deg, #c98d4e 0, #a56a35 60%, #7a4a22 100%);
  border-top: 4px solid var(--ink);
  transform: perspective(520px) rotateX(12deg);
  transform-origin: top center;
  box-shadow: inset 0 18px 30px rgba(0,0,0,.35);
}
.bk-floor::after {
  content: "";
  position: absolute; inset: 0;
  background: repeating-linear-gradient(0deg, rgba(58,33,21,.4) 0 3px, transparent 3px 36px), repeating-linear-gradient(90deg, rgba(58,33,21,.4) 0 3px, transparent 3px 72px);
}
.bk-sacks {
  position: absolute; bottom: 15%; left: 4%;
  font-size: 32px; letter-spacing: 2px;
  filter: drop-shadow(3px 3px 0 var(--ink));
  opacity: 1; pointer-events: none; z-index: 2;
}
.bk-sacks.right { left: auto; right: 4%; }
.bk-dust, .bk-embers { position: absolute; inset: 0; pointer-events: none; overflow: hidden; }
.bk-dust { z-index: 2; }
.bk-embers { z-index: 4; }
.bk-dust i {
  position: absolute; width: 6px; height: 6px; border-radius: 2px;
  background: rgba(255,240,200,.8);
  animation: bk-dust 7s linear infinite;
}
.bk-dust i:nth-child(1) { left: 12%; top: 32%; }
.bk-dust i:nth-child(2) { left: 24%; top: 56%; animation-delay: -1.2s; }
.bk-dust i:nth-child(3) { left: 38%; top: 24%; animation-delay: -2.4s; }
.bk-dust i:nth-child(4) { left: 55%; top: 50%; animation-delay: -.8s; }
.bk-dust i:nth-child(5) { left: 68%; top: 32%; animation-delay: -3.1s; }
.bk-dust i:nth-child(6) { left: 78%; top: 62%; animation-delay: -1.8s; }
.bk-dust i:nth-child(7) { left: 86%; top: 38%; animation-delay: -4s; }
.bk-dust i:nth-child(8) { left: 46%; top: 68%; animation-delay: -2s; }
.bk-dust i:nth-child(9) { left: 18%; top: 70%; animation-delay: -5s; }
.bk-dust i:nth-child(10) { left: 62%; top: 72%; animation-delay: -.4s; }
@keyframes bk-dust { 0% { transform: translateY(0); opacity: 0; } 15% { opacity: .9; } 100% { transform: translateY(-130px); opacity: 0; } }
.bk-embers i {
  position: absolute; bottom: 28%;
  width: 5px; height: 8px; border-radius: 50%;
  background: radial-gradient(circle, #ffe9a8 0, var(--crust) 60%, transparent 75%);
  animation: bk-ember 2.2s linear infinite;
  opacity: 0;
}
.bk-embers i:nth-child(1) { left: 42%; animation-delay: 0s; }
.bk-embers i:nth-child(2) { left: 48%; animation-delay: -.6s; }
.bk-embers i:nth-child(3) { left: 54%; animation-delay: -1.1s; }
.bk-embers i:nth-child(4) { left: 58%; animation-delay: -.3s; }
.bk-embers i:nth-child(5) { left: 45%; animation-delay: -1.6s; }
.bk-embers i:nth-child(6) { left: 51%; animation-delay: -.9s; }
@keyframes bk-ember { 0% { transform: translateY(0) scale(1); opacity: 0; } 15% { opacity: 1; } 100% { transform: translateY(-190px) scale(.4); opacity: 0; } }
.bk-warm {
  position: absolute; inset: 0; z-index: 1; pointer-events: none;
  background: radial-gradient(520px 380px at 50% 55%, rgba(255,170,60,.22), transparent 70%);
  opacity: 0; transition: opacity .4s;
}
.bk-scene.rush .bk-warm { opacity: 1; background: radial-gradient(620px 460px at 50% 55%, rgba(255,200,70,.5), rgba(255,120,30,.18) 60%, transparent 78%); }
.bk-scene.golden .bk-warm { opacity: 1; background: radial-gradient(620px 460px at 50% 55%, rgba(255,215,80,.55), rgba(255,180,40,.22) 60%, transparent 78%); }
.bk-scene.golden .bk-oven { box-shadow: inset 0 6px 0 rgba(255,255,255,.3), 0 0 80px rgba(255,210,63,.85); }
.bk-frenzy { font-family: var(--font-pixel); font-size: 10px; color: var(--ink); background: var(--chip); border: 3px solid var(--ink); border-radius: var(--r-pill); padding: 5px 12px; box-shadow: 0 3px 0 var(--ink), 0 0 16px rgba(255,210,63,.7); animation: bk-pulse 1s infinite alternate; }
.bk-rushaura {
  position: absolute; left: 50%; top: 54%;
  width: min(520px, 88%); aspect-ratio: 1;
  transform: translate(-50%,-50%);
  background: radial-gradient(circle, rgba(255,210,63,.55) 0, rgba(255,159,67,.28) 45%, transparent 70%);
  border-radius: 50%;
  z-index: 2; pointer-events: none;
  opacity: 0; transition: opacity .3s;
  animation: bk-aura 1.3s ease-in-out infinite alternate;
}
.bk-scene.rush .bk-rushaura { opacity: 1; }
@keyframes bk-aura { from { transform: translate(-50%,-50%) scale(1); } to { transform: translate(-50%,-50%) scale(1.08); } }
.bk-cookie {
  position: absolute;
  left: 50%; top: 54%;
  width: clamp(260px, 46vmin, 360px);
  height: clamp(260px, 46vmin, 360px);
  transform: translate(-50%,-50%);
  background: none; border: none; padding: 0;
  cursor: pointer;
  z-index: 3;
  animation: bk-idle 2.8s ease-in-out infinite alternate;
  filter: drop-shadow(0 10px 0 var(--ink)) drop-shadow(0 16px 22px rgba(0,0,0,.55));
  transition: transform .1s;
}
.bk-cookie:hover { filter: drop-shadow(0 10px 0 var(--ink)) drop-shadow(0 0 26px rgba(255,210,90,.7)); }
.bk-cookie:active, .bk-cookie.press { transform: translate(-50%,-50%) scale(.92); animation: none; }
.bk-cookie.glow { filter: drop-shadow(0 10px 0 var(--ink)) drop-shadow(0 0 44px rgba(255,210,63,.95)); }
.bk-cookie svg { width: 100%; height: 100%; display: block; }
@keyframes bk-idle { from { margin-top: 0; } to { margin-top: -10px; } }
.bk-scene.rush .bk-cookie { animation: bk-idle 1.2s ease-in-out infinite alternate; }
.bk-handwrap { position: absolute; transform: translate(-50%,-50%); display: flex; flex-direction: column; align-items: center; z-index: 4; pointer-events: none; }
.bk-handwrap.large { scale: 1.22; z-index: 4; }
.bk-handwrap.normal { scale: .96; z-index: 4; }
.bk-handwrap.dense { scale: .72; z-index: 4; }
.bk-handwrap.dense .bk-handname { display: none; }
.bk-handwrap.dots { scale: .6; z-index: 4; }
.bk-handwrap.lunging { animation: bk-lunge-dir var(--fx-lunge, 180ms); z-index: 5; }
.bk-handwrap.auto { animation: bk-auto var(--fx-auto, 280ms) ease; z-index: 5; }
.bk-handwrap.has-auto .bk-handavatar { outline-color: var(--chip); box-shadow: 0 0 10px rgba(255,210,63,.55), 0 3px 0 var(--ink); }
.bk-cookie:focus:not(:focus-visible) { outline: none; }
.bk-cookie:focus-visible { outline: 3px solid var(--chip); outline-offset: 6px; }
.bk-handwrap.is-self .bk-handname { background: #fff0b8; }
.bk-handwrap.is-self.rushing .bk-handavatar { outline: 3px solid var(--chip); box-shadow: 0 0 18px rgba(255,210,63,.9), 0 3px 0 var(--ink); }
.bk-handwrap.is-self.rushing .bk-handname { background: var(--chip); }
.bk-handwrap.auto-lv3 .bk-handavatar { box-shadow: 0 0 14px rgba(255,210,63,.75), 0 3px 0 var(--ink); }
.bk-handwrap.auto-lv5 .bk-handavatar { outline: 3px solid var(--chip); box-shadow: 0 0 18px rgba(255,210,63,.9), 0 3px 0 var(--ink); }
@keyframes bk-lunge { 0% { margin-top: 0; } 35% { margin-top: 20px; } 100% { margin-top: 0; } }
@keyframes bk-lunge-dir { 0% { translate: 0 0; } 35% { translate: var(--lx, 0px) var(--ly, 2px); } 100% { translate: 0 0; } }
@keyframes bk-auto { 0% { margin-top: 0; } 40% { margin-top: 14px; scale: 1.06; } 100% { margin-top: 0; } }
.bk-handavatar {
  width: 34px; height: 34px; border-radius: 50%;
  display: grid; place-items: center;
  font-weight: 900; font-size: 15px; color: #fff;
  background: var(--wood);
  border: 3px solid var(--color, #fff);
  outline: 3px solid var(--ink);
  box-shadow: 0 3px 0 var(--ink);
  text-shadow: 1px 1px 0 #000;
}
.bk-handtool { position: relative; width: 30px; height: 30px; margin-top: -10px; display: grid; place-items: center; background: var(--paper); border: 2px solid var(--ink); border-radius: 8px; box-shadow: 0 2px 0 var(--ink); filter: drop-shadow(1px 1px 0 rgba(0,0,0,.25)); }
.bk-handtool svg { display: block; }
.bk-handtool.auto-lv1 { background: #fff9e6; border-color: var(--ink); }
.bk-handtool.auto-lv3 { background: #fff0b8; border-color: var(--chip); box-shadow: 0 0 8px rgba(255,210,63,.6), 0 2px 0 var(--ink); }
.bk-handtool.auto-lv5 { background: linear-gradient(135deg, #fff0b8 0, #ffd23f 100%); border-color: var(--ink); outline: 2px solid var(--chip); box-shadow: 0 0 12px rgba(255,210,63,.8), 0 2px 0 var(--ink); }
.bk-tool-sparkle { position: absolute; top: -6px; right: -6px; width: 12px; height: 12px; display: grid; place-items: center; filter: drop-shadow(1px 1px 0 var(--ink)); animation: bk-twinkle 1.1s ease-in-out infinite alternate; }
@keyframes bk-twinkle { from { transform: scale(.85) rotate(-6deg); } to { transform: scale(1.15) rotate(6deg); } }
.bk-tool-steam { position: absolute; top: -10px; left: 50%; transform: translateX(-50%); display: flex; gap: 2px; pointer-events: none; }
.bk-tool-steam i { width: 4px; height: 4px; border-radius: 50%; background: rgba(255,255,255,.9); border: 1px solid var(--ink); opacity: .85; animation: bk-steam 1.2s ease-in-out infinite; }
.bk-tool-steam i:nth-child(2) { animation-delay: .2s; }
.bk-tool-steam i:nth-child(3) { animation-delay: .4s; }
@keyframes bk-steam { 0% { transform: translateY(0); opacity: .85; } 100% { transform: translateY(-8px); opacity: 0; } }
.bk-tool-mech { position: absolute; inset: -4px -6px -6px -6px; border: 2px dashed var(--ink); border-radius: 10px; background: repeating-linear-gradient(45deg, rgba(58,33,21,.12) 0 4px, transparent 4px 8px); pointer-events: none; z-index: -1; }
.bk-shelf-icon { display: grid; place-items: center; width: 28px; height: 28px; background: var(--paper); border: 2px solid var(--ink); border-radius: 8px; box-shadow: 0 2px 0 var(--ink); }
.bk-handname {
  font-size: 11px; font-weight: 900; color: var(--ink);
  background: var(--paper);
  border: 2px solid var(--ink);
  border-radius: var(--r-pill);
  padding: 1px 8px; margin-top: 2px; white-space: nowrap;
  box-shadow: 0 2px 0 var(--ink);
}
.bk-crowddot { position: absolute; width: 15px; height: 15px; border-radius: 50%; border: 3px solid var(--ink); opacity: .95; z-index: 1; animation: bk-dotbob 1.8s ease-in-out infinite alternate; will-change: transform; }
@keyframes bk-dotbob { from { transform: translateY(0); } to { transform: translateY(-7px); } }
.bk-fx { position: absolute; inset: 0; z-index: 5; cursor: pointer; pointer-events: auto; overflow: visible; }
.bk-fx .bk-ripple, .bk-fx .bk-crumb, .bk-fx .bk-float { z-index: 6; }
.bk-ripple { position: absolute; width: 64px; height: 64px; margin: -32px; border: 4px solid #fff3d0; border-radius: 50%; animation: bk-rip var(--fx-ripple, 950ms) ease-out forwards; pointer-events: none; box-shadow: 0 0 16px rgba(255,223,158,.9), 0 0 4px rgba(0,0,0,.6); will-change: transform, opacity; }
.bk-ripple.auto { width: 38px; height: 38px; margin: -19px; border-width: 3px; border-color: #ffd23f; opacity: .9; animation: bk-rip-auto var(--fx-ripple, 950ms) ease-out forwards; box-shadow: 0 0 10px rgba(255,210,63,.7); }
@keyframes bk-rip { from { transform: scale(.3); opacity: 1; } to { transform: scale(1.5); opacity: 0; } }
@keyframes bk-rip-auto { from { transform: scale(.25); opacity: .95; } to { transform: scale(1.35); opacity: 0; } }
.bk-crumb { position: absolute; background: #7a3f12; border: 2px solid var(--ink); border-radius: 3px; animation: bk-crumb var(--fx-crumb, 950ms) ease-out forwards; pointer-events: none; }
.bk-crumb.alt { background: var(--chip); }
@keyframes bk-crumb { from { transform: translate(0,0) rotate(0); opacity: 1; } to { transform: translate(var(--dx), var(--dy)) rotate(220deg); opacity: 0; } }
.bk-float {
  position: absolute; transform: translate(-50%,-130%);
  font-family: var(--font-pixel); font-size: 15px;
  color: #fff; text-shadow: 2px 2px 0 var(--ink), -1px -1px 0 var(--ink), 0 0 10px rgba(0,0,0,.8);
  animation: bk-floatup var(--fx-floater, 950ms) ease-out forwards; pointer-events: none; white-space: nowrap;
}
.bk-float.big { font-size: 21px; color: var(--chip); }
@keyframes bk-floatup { from { opacity: 1; margin-top: 0; } to { opacity: 0; margin-top: -90px; } }
.bk-hidden { position: absolute; right: 10px; top: 56px; background: var(--ink); color: var(--chip); font-family: var(--font-pixel); font-size: 10px; border-radius: var(--r-pill); padding: 5px 11px; z-index: 6; border: 2px solid var(--chip); }
.bk-countblock { position: absolute; left: 0; right: 0; bottom: 12px; z-index: 6; pointer-events: none; display: flex; flex-direction: column; align-items: center; gap: 6px; }
.bk-bignum {
  display: inline-block;
  font-family: var(--font-pixel); font-size: 15px; color: var(--ink);
  background: var(--paper); border: var(--outline); border-radius: 14px;
  padding: 8px 18px; box-shadow: var(--shadow-hard);
}
.bk-credits-pill { background: linear-gradient(180deg, #7a4a2b 0, #4a2a18 100%); color: var(--chip); border: 3px solid var(--ink); text-shadow: 2px 2px 0 var(--ink); box-shadow: 0 4px 0 var(--ink), 0 6px 18px rgba(0,0,0,.45), 0 0 18px rgba(255,210,63,.32); font-size: 14px; padding: 10px 20px; }
.bk-credits-pill.bump { animation: bk-credit-bump var(--fx-bump, 600ms) ease; }
@keyframes bk-credit-bump { 0% { transform: scale(1); } 30% { transform: scale(1.07); } 55% { transform: scale(0.99); } 100% { transform: scale(1); } }
.bk-credit-hint { font-size: 11px; font-weight: 900; color: var(--paper); background: rgba(0,0,0,.58); border: 2px solid rgba(255,243,208,.45); padding: 3px 10px; border-radius: var(--r-pill); line-height: 1; }
.bk-bakery-total { font-size: 10px; font-weight: 800; color: rgba(255,243,208,.92); background: rgba(58,33,21,.62); border: 1.5px solid rgba(255,243,208,.28); padding: 2px 9px; border-radius: var(--r-pill); text-shadow: 1px 1px 0 var(--ink); line-height: 1; }
.bk-cpsline { margin-top: 6px; display: inline-block; font-size: 12px; font-weight: 900; color: var(--paper); background: rgba(0,0,0,.62); border: 2px solid rgba(255,243,208,.5); padding: 3px 12px; border-radius: var(--r-pill); }
.bk-calm-msg {
  position: absolute; left: 50%; top: 15%;
  transform: translateX(-50%) translateY(-6px);
  background: var(--paper);
  border: 3px solid var(--ink);
  color: var(--ink);
  font-size: 13px; font-weight: 800;
  border-radius: 12px; padding: 8px 14px;
  z-index: 6; white-space: nowrap;
  box-shadow: var(--shadow-hard);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.6s ease, transform 0.6s ease;
}
.bk-calm-msg.visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(-50%) translateY(0);
}
.bk-hint { text-align: center; font-size: 12px; color: var(--cream); font-weight: 800; text-shadow: 1px 1px 0 var(--ink); }
.bk-toasts { display: flex; flex-direction: column; gap: 6px; align-items: center; min-height: 8px; }
.bk-toast { background: var(--paper); border: 3px solid var(--ink); border-radius: 12px; padding: 6px 14px; font-size: 13px; font-weight: 800; color: var(--ink); box-shadow: var(--shadow-hard); animation: bk-toastin .25s; }
.bk-toast.gold { background: var(--chip); }
@keyframes bk-toastin { from { transform: translateY(8px); opacity: 0; } to { transform: none; opacity: 1; } }
.bk-event-card { position: relative; border-radius: var(--r-card); padding: 14px 12px 12px; border: var(--outline); background: var(--paper); margin-bottom: 12px; color: var(--ink); box-shadow: var(--shadow-hard); overflow: hidden; }
.bk-event-card::before { content: ""; position: absolute; top: -8px; left: 50%; transform: translateX(-50%) rotate(-2deg); width: 84px; height: 18px; background: rgba(255,223,158,.9); border: 2px solid rgba(58,33,21,.3); }
.bk-event-card.calm { background: #efe6d2; }
.bk-event-card.active { background: linear-gradient(180deg, #fff6d8, var(--cream)); outline: 3px solid var(--chip); outline-offset: 2px; }
.bk-event-card.soon { background: var(--chip); animation: bk-pulse .8s infinite alternate; }
.bk-event-card.done { background: #d8f5df; outline: 3px solid var(--mint); outline-offset: 2px; }
.bk-evtitle { font-family: var(--font-pixel); font-size: 12px; }
.bk-evtime { font-size: 16px; margin: 6px 0; color: #9a3d00; }
.bk-evbonus { font-size: 13px; color: var(--ink-soft); font-weight: 700; line-height: 1.5; }
.bk-mecard { background: #4a2f1c; border: 3px solid var(--ink); border-radius: var(--r-card); padding: 11px; box-shadow: 0 3px 0 var(--ink); color: var(--paper); }
.bk-metitle { font-weight: 900; font-size: 13px; margin-bottom: 6px; color: #fff; }
.bk-merow { display: flex; justify-content: space-between; font-size: 13px; padding: 5px 0; border-top: 2px dashed rgba(255,243,208,.3); color: var(--cream); font-variant-numeric: tabular-nums; }
.bk-merow b { font-family: var(--font-pixel); font-size: 11px; color: var(--chip); }
.bk-sub { grid-template-columns: 1fr; }
.bk-wide {
  max-width: 820px; width: 100%; margin: 0 auto;
  background: var(--paper);
  border: var(--outline); border-radius: var(--r-card);
  box-shadow: var(--shadow-pop);
  padding: 14px; color: var(--ink);
  position: relative;
}
.bk-nav {
  position: sticky; bottom: 0; z-index: 20;
  display: grid; grid-template-columns: repeat(6, minmax(0, 1fr));
  background: linear-gradient(180deg, #5a3421, #3a2115);
  border-top: var(--outline);
  padding: 8px 10px calc(8px + var(--saib));
  padding-left: calc(10px + var(--sail));
  padding-right: calc(10px + var(--sair));
  gap: 8px;
}
.bk-navbtn {
  position: relative;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px;
  background: #fff9e6;
  color: var(--ink-soft);
  border: 3px solid var(--ink);
  border-radius: 14px;
  padding: 8px 4px;
  font-size: 11px; font-weight: 900;
  cursor: pointer;
  box-shadow: 0 3px 0 var(--ink);
  min-height: 56px;
  min-width: 0;
  max-width: 100%;
  overflow: visible;
  white-space: nowrap;
  box-sizing: border-box;
  touch-action: manipulation;
}
.bk-navbtn:active { transform: translateY(2px); box-shadow: 0 1px 0 var(--ink); }
.bk-navbtn.on {
  background: var(--berry);
  color: #fff;
  border: 3px solid var(--ink);
  outline: 3px solid var(--chip);
  outline-offset: 1px;
  text-shadow: 1px 1px 0 var(--ink);
}
.bk-nico { font-size: 20px; }
.bk-badge { position: absolute; top: -10px; right: -6px; background: var(--cherry); color: #fff; font-family: var(--font-pixel); font-size: 9px; border-radius: var(--r-pill); min-width: 22px; height: 22px; display: grid; place-items: center; border: 3px solid var(--ink); z-index: 2; pointer-events: none; }
.bk-root.rm .bk-status.rush, .bk-root.rm .bk-status.chaos, .bk-root.rm .bk-event-card.soon, .bk-root.rm .bk-event-chip.rush { animation: none; }
.bk-root.rm .bk-float { animation-duration: var(--fx-floater-reduced, 400ms); }
.bk-root.rm .bk-dust, .bk-root.rm .bk-embers { display: none; }
.bk-root.rm .bk-ripple { animation-duration: var(--fx-ripple-reduced, 200ms); }
.bk-root.rm .bk-crumb { animation-duration: var(--fx-crumb-reduced, 200ms); }
.bk-root.rm .bk-handwrap.lunging, .bk-root.rm .bk-handwrap.auto { animation: none; }
.bk-root.rm .bk-handtool .bk-tool-sparkle, .bk-root.rm .bk-tool-steam i { animation: none; }
.bk-root.rm .bk-ripple.auto { display: none; }
.bk-root.rm .bk-fire i, .bk-root.rm .bk-cookie, .bk-root.rm .bk-scene.chaos, .bk-root.rm .bk-rushaura, .bk-root.rm .bk-credits-pill.bump, .bk-root.rm .bk-frenzy { animation: none; }
.bk-sneaky {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid var(--ink);
  background: radial-gradient(circle at 35% 30%, #fff6c8 0, #ffd08a 28%, #d9984a 58%, #7a4a18 100%);
  display: grid;
  place-items: center;
  cursor: pointer;
  z-index: 6;
  box-shadow: 0 2px 0 var(--ink), 0 0 0 2px rgba(255,210,63,.0);
  animation: bk-sneaky-wobble 2.2s ease-in-out infinite alternate, bk-sneaky-glow 1.6s ease-in-out infinite alternate;
  opacity: .92;
}
.bk-sneaky:hover { opacity: 1; }
.bk-sneaky:active { opacity: 1; }
.bk-sneaky-cookie { font-size: 14px; line-height: 1; filter: drop-shadow(1px 1px 0 var(--ink)); }
.bk-sneaky-glow {
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,210,63,.45) 0, transparent 70%);
  pointer-events: none;
  animation: bk-sneaky-pulse 1.4s ease-in-out infinite alternate;
}
.bk-sneaky-sparkle {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 10px;
  filter: drop-shadow(1px 1px 0 var(--ink));
  animation: bk-twinkle 1s ease-in-out infinite alternate;
  pointer-events: none;
}
@keyframes bk-sneaky-wobble { from { margin-top: 0; } to { margin-top: -4px; } }
@keyframes bk-sneaky-glow { from { box-shadow: 0 0 0 0 rgba(255,210,63,.0); } to { box-shadow: 0 0 10px 2px rgba(255,210,63,.55); } }
@keyframes bk-sneaky-pulse { from { opacity: .6; transform: scale(.9); } to { opacity: 1; transform: scale(1.08); } }
.bk-root.rm .bk-sneaky, .bk-root.rm .bk-sneaky-glow, .bk-root.rm .bk-sneaky-sparkle { animation: none; }
.bk-mini {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid var(--ink);
  background: radial-gradient(circle at 35% 30%, #fff6c8 0, #ffd08a 28%, #d9984a 58%, #7a4a18 100%);
  display: grid;
  place-items: center;
  cursor: pointer;
  z-index: 6;
  box-shadow: 0 2px 0 var(--ink), 0 0 0 2px rgba(255,210,63,.0);
  animation: bk-sneaky-wobble 2.2s ease-in-out infinite alternate, bk-sneaky-glow 1.6s ease-in-out infinite alternate;
  opacity: .95;
}
.bk-mini:hover { opacity: 1; }
.bk-mini:active { opacity: 1; transform: translate(-50%, -50%) scale(.92); }
.bk-mini-cookie { font-size: 17px; line-height: 1; filter: drop-shadow(1px 1px 0 var(--ink)); }
.bk-mini-glow {
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255,210,63,.45) 0, transparent 70%);
  pointer-events: none;
  animation: bk-sneaky-pulse 1.4s ease-in-out infinite alternate;
}
.bk-mini-mult {
  position: absolute;
  bottom: -10px;
  right: -12px;
  font-family: var(--font-pixel);
  font-size: 8px;
  background: #ffd23f;
  color: var(--ink);
  border: 2px solid var(--ink);
  border-radius: 999px;
  padding: 1px 5px;
  line-height: 1.4;
  pointer-events: none;
  box-shadow: 0 2px 0 var(--ink);
}
.bk-root.rm .bk-mini, .bk-root.rm .bk-mini-glow { animation: none; }

.bk-cloud-wrap { position: absolute; right: 12px; bottom: 64px; z-index: 7; display: flex; flex-direction: column; align-items: flex-end; }
.bk-cloud { position: relative; display: flex; align-items: center; gap: 8px; background: linear-gradient(180deg, #fffdf2 0, #efe6c8 100%); border: 3px solid var(--ink); border-radius: 999px; padding: 8px 14px 8px 10px; box-shadow: 0 4px 0 var(--ink), 0 10px 22px rgba(0,0,0,.38), 0 0 0 3px rgba(255,243,208,.55); cursor: pointer; font-weight: 900; color: var(--ink); font-size: 12px; line-height: 1; transition: box-shadow .12s; min-height: 44px; box-sizing: border-box; }
.bk-cloud:hover, .bk-cloud:focus-visible { box-shadow: 0 4px 0 var(--ink), 0 14px 26px rgba(0,0,0,.42), 0 0 0 3px var(--chip); outline: none; }
.bk-cloud:active { box-shadow: 0 2px 0 var(--ink), 0 6px 14px rgba(0,0,0,.35); }
.bk-cloud-puffs { position: absolute; inset: -6px -8px -8px -8px; pointer-events: none; z-index: -1; }
.bk-cloud-puffs i { position: absolute; background: #fffdf2; border: 3px solid var(--ink); border-radius: 50%; box-shadow: 0 2px 0 var(--ink); }
.bk-cloud-puffs i:nth-child(1) { width: 28px; height: 28px; left: 6px; top: -4px; }
.bk-cloud-puffs i:nth-child(2) { width: 22px; height: 22px; right: 18px; top: -6px; }
.bk-cloud-puffs i:nth-child(3) { width: 18px; height: 18px; right: -2px; bottom: 6px; }
.bk-cloud-emoji { font-size: 18px; line-height: 1; filter: drop-shadow(1px 1px 0 var(--ink)); flex: none; }
.bk-cloud-count { font-family: var(--font-pixel); font-size: 10px; white-space: nowrap; }
.bk-cloud-tip { position: absolute; bottom: calc(100% + 14px); right: 0; width: min(340px, 78vw); max-height: 320px; background: var(--paper); border: var(--outline); border-radius: 16px; box-shadow: var(--shadow-pop), 0 12px 28px rgba(0,0,0,.4); overflow: hidden; display: flex; flex-direction: column; opacity: 0; visibility: hidden; transform: translateY(6px) scale(.98); transition: opacity .18s, transform .18s, visibility .18s; pointer-events: none; z-index: 8; }
.bk-cloud-wrap:hover .bk-cloud-tip, .bk-cloud-wrap:focus-within .bk-cloud-tip, .bk-cloud-tip.open { opacity: 1; visibility: visible; transform: translateY(0) scale(1); pointer-events: auto; }
.bk-cloud-tip-head { font-family: var(--font-pixel); font-size: 11px; color: var(--ink); padding: 10px 12px 6px; border-bottom: 3px solid var(--ink); background: #fff6d8; }
.bk-cloud-tip-sub { font-size: 11px; font-weight: 800; color: var(--ink-soft); padding: 6px 12px 8px; border-bottom: 2px dashed rgba(58,33,21,.18); background: var(--paper); }
.bk-cloud-list { overflow-y: auto; flex: 1; display: flex; flex-direction: column; gap: 6px; padding: 8px; scrollbar-width: thin; scrollbar-color: var(--wood) var(--cream); }
.bk-cloud-row { display: grid; grid-template-columns: 30px 1fr auto; grid-template-rows: auto auto; gap: 2px 8px; align-items: center; background: #fff9e6; border: 2px solid var(--ink); border-radius: 12px; padding: 6px 8px; box-shadow: 0 2px 0 var(--ink); }
.bk-cloud-ava { width: 28px; height: 28px; border-radius: 50%; display: grid; place-items: center; font-size: 12px; font-weight: 900; color: #fff; border: 2px solid var(--ink); flex: none; grid-row: 1 / 3; text-shadow: 1px 1px 0 #000; }
.bk-cloud-name { font-size: 12px; font-weight: 900; color: var(--ink); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.bk-cloud-spec { font-size: 10px; font-weight: 900; color: var(--ink-soft); background: var(--cream); border: 2px solid var(--ink); padding: 1px 6px; border-radius: 999px; justify-self: start; }
.bk-cloud-meta { font-size: 10px; font-weight: 800; color: var(--ink-soft); white-space: nowrap; }
.bk-cloud-contrib { grid-column: 2 / 4; font-size: 10px; font-weight: 900; color: var(--wood-dark); font-variant-numeric: tabular-nums; }
.cps-wrap { position: relative; display: inline-flex; }
.bk-cps-tip {
  position: absolute; top: calc(100% + 8px); left: 50%; transform: translateX(-50%) translateY(4px);
  min-width: 220px; max-width: min(300px, 80vw);
  background: var(--paper); color: var(--ink);
  border: var(--outline); border-radius: 12px; box-shadow: var(--shadow-pop);
  padding: 8px; display: flex; flex-direction: column; gap: 4px;
  opacity: 0; visibility: hidden; pointer-events: none;
  transition: opacity .15s, transform .15s, visibility .15s;
  z-index: 40;
}
.cps-wrap:hover .bk-cps-tip, .cps-wrap:focus-visible .bk-cps-tip, .cps-wrap:focus-within .bk-cps-tip {
  opacity: 1; visibility: visible; pointer-events: auto; transform: translateX(-50%) translateY(0);
}
.bk-cps-tip-title { font-family: var(--font-pixel); font-size: 10px; }
.bk-cps-row { display: flex; justify-content: space-between; gap: 8px; font-size: 12px; font-weight: 800; }
.bk-cps-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 120px; }
.bk-cps-val { white-space: nowrap; font-variant-numeric: tabular-nums; }
.bk-usermenu { position: relative; }
.bk-userbtn { max-width: 140px; overflow: hidden; text-overflow: ellipsis; }
.bk-usermenu-pop {
  position: absolute; right: 0; top: calc(100% + 8px);
  background: var(--paper); border: var(--outline); border-radius: 12px;
  box-shadow: var(--shadow-pop); padding: 6px; z-index: 50; min-width: 140px;
}
.bk-signout { width: 100%; }
.bk-menu-pages { min-width: 0; width: 100%; max-width: 100%; overflow-x: clip; box-sizing: border-box; }
.bk-main.bk-sub { min-width: 0; overflow-x: clip; }
.bk-wide { min-width: 0; max-width: 100%; overflow-x: clip; box-sizing: border-box; }
@media (max-width: 1020px) {
  .bk-main { grid-template-columns: minmax(0,1fr); padding: 10px calc(10px + var(--sair)) calc(100px + var(--saib)) calc(10px + var(--sail)); overflow-x: clip; }
  .bk-main.bk-sub { grid-template-columns: minmax(0,1fr); padding: 10px calc(10px + var(--sair)) calc(100px + var(--saib)) calc(10px + var(--sail)); overflow-x: clip; }
  .bk-side.left { order: 2; min-width: 0; }
  .bk-stage { order: 1; min-width: 0; }
  .bk-side.right { order: 3; min-width: 0; }
  .bk-scene { min-height: 540px; }
  .bk-roster { flex-direction: row; overflow-x: auto; overflow-y: hidden; max-height: none; padding-bottom: 6px; }
  .bk-roster li { flex: none; }
  .bk-nav { position: fixed; left: 0; right: 0; bottom: 0; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 6px; padding: 6px 6px calc(6px + var(--saib)); padding-left: calc(6px + var(--sail)); padding-right: calc(6px + var(--sair)); }
  .bk-navbtn { padding: 6px 2px; font-size: 10px; min-height: 52px; border-radius: 12px; }
  .bk-nico { font-size: 18px; }
  .bk-cookie { width: max(260px, 62vw); height: max(260px, 62vw); }
  .bk-header { gap: 8px; }
  .bk-cookie-pill { order: 3; width: 100%; justify-content: center; box-sizing: border-box; }
  .bk-wide { padding: 10px; }
}
@media (prefers-reduced-motion: reduce) {
  .bk-crowddot { animation: none; }
  .bk-status.rush, .bk-status.chaos, .bk-event-card.soon, .bk-scene.chaos, .bk-cookie, .bk-fire i, .bk-dust i, .bk-embers i, .bk-credits-pill.bump, .bk-handwrap.lunging, .bk-handwrap.auto { animation: none; }
  .bk-handtool .bk-tool-sparkle, .bk-tool-steam i { animation: none; }
  .bk-ripple.auto { display: none; }
}
.bk-skel {
  background: var(--cream);
  border: 3px solid var(--ink);
  border-radius: 12px;
  box-shadow: 0 3px 0 var(--ink);
}
.bk-skel-line {
  border-radius: 999px;
  display: block;
}
.bk-skel-pill {
  border-radius: 999px;
}
.bk-skel-ico {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  flex: none;
}
.bk-skel-ava {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.bk-skel-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff9e6;
  border: 3px solid var(--ink);
  border-radius: 12px;
  padding: 5px 8px;
  box-shadow: 0 2px 0 var(--ink);
}
.bk-skel-card {
  border-radius: var(--r-card);
  border: var(--outline);
  box-shadow: var(--shadow-hard);
}
.bk-shimmer {
  background: linear-gradient(90deg, #ffe9b0 25%, #fff3d0 50%, #ffe9b0 75%);
  background-size: 200% 100%;
  animation: bk-shimmer 1.35s linear infinite;
}
@keyframes bk-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.bk-skel-dim {
  opacity: .38;
  filter: saturate(.65);
}
.bk-skel-scene {
  background: #3d2414;
}
.bk-skel-scene .bk-wall,
.bk-skel-scene .bk-oven,
.bk-skel-scene .bk-floor,
.bk-skel-scene .bk-beams {
  opacity: .38;
}
.bk-skel-cookie {
  position: absolute;
  left: 50%;
  top: 54%;
  width: clamp(260px, 46vmin, 360px);
  height: clamp(260px, 46vmin, 360px);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(circle at 38% 34%, #ffdf9e 0, #d9984a 52%, #7a4a18 100%);
  border: 4px solid var(--ink);
  box-shadow: 0 10px 0 var(--ink), 0 16px 22px rgba(0,0,0,.45), inset 0 0 22px rgba(255,255,255,.22);
  animation: bk-skel-pulse 1.45s ease-in-out infinite alternate;
  z-index: 3;
}
@keyframes bk-skel-pulse {
  from { transform: translate(-50%, -50%) scale(1); opacity: .92; }
  to { transform: translate(-50%, -50%) scale(1.04); opacity: 1; }
}
.bk-skel-nav {
  opacity: .62;
  pointer-events: none;
  filter: saturate(.7);
}
.bk-skel-nav .bk-navbtn {
  justify-content: center;
  gap: 6px;
  background: #fff9e6;
}
.bk-root.rm .bk-shimmer,
.bk-root.rm .bk-skel-cookie {
  animation: none;
}
.bk-root.rm .bk-crowddot {
  animation: none;
}

.bk-fx.trail-crumb_trail .bk-float { color: #ff9b2e; text-shadow: 0 0 8px rgba(255,155,46,0.95), 0 0 18px rgba(255,155,46,0.65), 2px 2px 0 rgba(0,0,0,0.9); }
.bk-fx.trail-spark_trail .bk-float { color: #fff04a; text-shadow: 0 0 10px rgba(255,240,74,1), 0 0 22px rgba(255,240,74,0.85), 2px 2px 0 rgba(0,0,0,0.9); }
.bk-fx.trail-comet_trail .bk-float { color: #5cc8ff; text-shadow: 0 0 10px rgba(92,200,255,1), 0 0 22px rgba(92,200,255,0.85), 2px 2px 0 rgba(0,0,0,0.9); }
.cb-card.equipped-accent { outline: 3px solid var(--chip); outline-offset: -2px; box-shadow: 0 0 14px rgba(255,210,63,0.6); }
